import { createDirectionsController } from '@uofu-uss-gis/ui-react';

export const classMapDirectionsController = createDirectionsController();
